module.exports = __webpack_public_path__ + "static/media/screenNotes.afb8a83a.png";